import { Component } from '@angular/core';
import { CookieAdapterService } from '../../core/cookie-adapter.service';
import { OeAppService } from '../../shared/oe-app.service';

@Component({
  selector: 'lp2-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent {
  isCookieNoticeVisible: boolean;
  constructor(private cookieService: CookieAdapterService, private oeAppService: OeAppService) {
    const cookieNoticeCookie = this.cookieService.get('cookie_notice');
    this.isCookieNoticeVisible = cookieNoticeCookie == null;
  }

  public get isMobileDevice() {
    return this.oeAppService.isMobileDevice();
  }

  hideCookieNotice() {
    this.isCookieNoticeVisible = false;
    this.cookieService.put('cookie_notice', 'true');
  }
}



// WEBPACK FOOTER //
// ./ts/app/login/login-page/login-page.component.ts